import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Api from '../../service/Api';
import { getProp, __, setProp } from '../../utilities/common';
import { setAlert } from './../../actions';
import Loader from './../../component/loader';
import cx from 'classnames';
import Datepicker from '../../component/form/datepicker';
import moment from 'moment';
import Checkbox from '../../component/form/checkbox';

class FormAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      saveOtaUpdateLoader: false,
      formData: {
        ecrVersionMin: '',
        icmVersionMin: '',
        file: null,
        date: null,
        time: '',
        deadlineDate: null,
        deadlineTime: '',
        deadline: false,
        active: true,
      },
      formErrors: {},
    };
  }

  onChangeFormDataProp = (prop, e) => {
    const formData = setProp(this.state.formData, prop, e.target.value);

    this.setState({
      formData,
    });
  };

  onChangeFile = e => {
    let file = null;

    if (e.target.files.length > 0) {
      file = e.target.files[0];
    }

    const formData = setProp(this.state.formData, 'file', file);

    this.setState({
      formData,
    });
  };

  onChangeFormDataPropCheckbox = (prop, e) => {
    const formData = setProp(this.state.formData, prop, e.target.checked);

    this.setState({
      formData,
    });
  };

  onChangeFormDataDate = date => {
    const formData = setProp(
      this.state.formData,
      'date',
      date ? moment(date) : null,
    );

    if (date === null) {
      setProp(formData, 'time', '');
    }

    this.setState({
      formData,
    });
  };

  onChangeFormDataDeadlineDate = date => {
    const formData = setProp(
      this.state.formData,
      'deadlineDate',
      date ? moment(date) : null,
    );

    if (date === null) {
      setProp(formData, 'deadlineTime', '');
    }

    this.setState({
      formData,
    });
  };

  getFormProp = (prop, defaultValue = '') => {
    const { formData } = this.state;

    return getProp(formData, prop, defaultValue);
  };

  onSubmit = e => {
    e.preventDefault();

    const { dispatch } = this.props;
    const { formData } = this.state;
    const versionPattern = /^\d+\.\d+\.\d+$/;
    const file = getProp(formData, 'file');
    const ecrVersionMin = getProp(formData, 'ecrVersionMin');
    const icmVersionMin = getProp(formData, 'icmVersionMin');
    const date = getProp(formData, 'date');
    const time = getProp(formData, 'time');
    const deadlineDate = getProp(formData, 'deadlineDate');
    const deadlineTime = getProp(formData, 'deadlineTime');
    const deadline = getProp(formData, 'deadline');
    const active = getProp(formData, 'active');
    const POSTobj = new FormData();

    let err = false;
    let formErrors = {};

    this.setState(
      {
        saveOtaUpdateLoader: true,
        formErrors,
      },
      () => {
        if (!file) {
          formErrors.otaupdate = __('Vyberte súbor pre upload');
          err = true;
        } else {
          POSTobj.append('otaupdate', file);
        }

        // Validate and add availability
        let datetime = null;
        if (date !== null) {
          datetime = moment(date);
          datetime.startOf('date');

          // Check time
          const timePattern = /^([01]\d|2[0-3]):?([0-5]\d)$/;

          if (time.trim() !== '') {
            if (!timePattern.test(time)) {
              formErrors.time = __('Zadajte platný čas vo formáte 00:00');
              err = true;
            } else {
              const timeParsed = time.split(':');

              datetime.hours(timeParsed[0]);
              datetime.minutes(timeParsed[1]);
            }
          }

          POSTobj.append('availability', datetime.toISOString());
        }

        // Validate and add deadline
        let deadlineDatetime = null;
        if (deadlineDate !== null) {
          deadlineDatetime = moment(deadlineDate);
          deadlineDatetime.startOf('date');

          // Check deadline time
          const timePattern = /^([01]\d|2[0-3]):?([0-5]\d)$/;

          if (deadlineTime.trim() !== '') {
            if (!timePattern.test(deadlineTime)) {
              formErrors.deadlineTime = __(
                'Zadajte platný čas vo formáte 00:00',
              );
              err = true;
            } else {
              const timeParsed = deadlineTime.split(':');

              deadlineDatetime.hours(timeParsed[0]);
              deadlineDatetime.minutes(timeParsed[1]);
            }
          }

          // Check if deadline is after availability
          if (
            datetime &&
            deadlineDatetime &&
            deadlineDatetime.isSameOrBefore(datetime)
          ) {
            formErrors.deadlineDate = __(
              'Deadline musí byť po dátume platnosti od',
            );
            err = true;
          }

          POSTobj.append(
            'update_deadline_date',
            deadlineDatetime.toISOString(),
          );
        } else {
          POSTobj.append('update_deadline_date', null);
        }

        // Add deadline boolean and active status
        POSTobj.append('deadline', Boolean(deadline));
        POSTobj.append('active', Boolean(active));

        if (ecrVersionMin.trim() !== '') {
          if (!versionPattern.test(ecrVersionMin)) {
            formErrors.ecr_version_min = __(
              'Zadajte min. ECR verziu vo formáte 0.0.0',
            );
            err = true;
          } else {
            POSTobj.append('ecr_version_min', ecrVersionMin);
          }
        }

        if (icmVersionMin.trim() !== '') {
          if (!versionPattern.test(icmVersionMin)) {
            formErrors.icm_version_min = __(
              'Zadajte min. SM verziu vo formáte 0.0.0',
            );
            err = true;
          } else {
            POSTobj.append('icm_version_min', icmVersionMin);
          }
        }

        if (err) {
          this.setState({
            saveOtaUpdateLoader: false,
            formErrors,
          });

          if (formErrors) {
            for (let a in formErrors) {
              if (!formErrors.hasOwnProperty(a)) continue;

              dispatch(
                setAlert({
                  type: 'warning',
                  title: formErrors[a],
                  onConfirm: () => dispatch(setAlert(null)),
                }),
              );

              break;
            }
          }

          return;
        }

        Api.post(`/admin/otaupdates`, POSTobj, null)
          .then(response => {
            this.setState({
              saveOtaUpdateLoader: false,
            });

            this.props.onSuccess(true);
            this.context.router.push(this.props.returnUrl);
          })
          .catch(error => {
            this.setState({
              saveOtaUpdateLoader: false,
            });

            if (error.response.status === 400) {
              if (error.details.name === 'INVALID_SCHEMA') {
                const paths = getProp(error.details, 'payload.paths', []);

                for (const path of paths) {
                  const realt_path = path.split('.');

                  formErrors[realt_path[0]] = true;
                }

                this.setState({ formErrors });

                dispatch(
                  setAlert({
                    type: 'warning',
                    title: __('Nesprávne vyplnená položka'),
                    onConfirm: () => dispatch(setAlert(null)),
                  }),
                );
              } else if (error.details.name === 'BAD_REQUEST') {
                dispatch(
                  setAlert({
                    type: 'warning',
                    title: __('Vyberte správny súbor pre nahratie'),
                    onConfirm: () => dispatch(setAlert(null)),
                  }),
                );
              }
            } else {
              dispatch(
                setAlert({
                  type: 'error',
                  title: __('Pri ukladaní nastala neznáma chyba'),
                  onConfirm: () => dispatch(setAlert(null)),
                }),
              );
            }
          });
      },
    );
  };

  render() {
    const { saveOtaUpdateLoader, formErrors } = this.state;

    const printFileInfo = () => {
      const { formData } = this.state;
      const file = formData.file;

      if (file) {
        return (
          <div>
            {getProp(file, 'name')} ({getProp(file, 'size')}b)
          </div>
        );
      }

      return null;
    };

    return (
      <div>
        <h2 className="side-panel-title">{__('Nová aktualizácia')}</h2>
        <hr />
        <Loader show={saveOtaUpdateLoader}>
          <form className="form-horizontal" onSubmit={this.onSubmit}>
            <fieldset className="fieldset">
              <div
                className={cx('form-group', {
                  'has-error': 'otaupdate' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Aktualizačný súbor')}:
                </label>
                <div className="col-xs-8">
                  <input
                    type="file"
                    className="form-control"
                    style={{ border: 'none' }}
                    onChange={this.onChangeFile}
                  />
                  {printFileInfo()}
                </div>
              </div>
              <div className="form-group">
                <div className="col-xs-8 col-xs-offset-4 checkbox">
                  <Checkbox
                    id="ota-update-active"
                    checked={this.getFormProp('active', true)}
                    onChange={e => {
                      this.onChangeFormDataPropCheckbox('active', e);
                    }}
                  />
                  <label htmlFor="ota-update-active">{__('Aktívny')}</label>
                </div>
              </div>
              <div
                className={cx('form-group', {
                  'has-error':
                    'availability' in formErrors || 'date' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Platné od (dátum)')}:
                </label>
                <div className="col-sm-4 col-xs-8">
                  <Datepicker
                    selected={this.getFormProp('date', null)}
                    dateFormat="dd.MM.yyyy"
                    onChange={this.onChangeFormDataDate}
                    placeholderText="01.01.2000"
                  />
                </div>
              </div>
              <div
                className={cx('form-group', {
                  'has-error':
                    'availability' in formErrors || 'time' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Platné od (čas)')}:
                </label>
                <div className="col-xs-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="00:00"
                    onChange={e => {
                      this.onChangeFormDataProp('time', e);
                    }}
                    value={this.getFormProp('time')}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="col-xs-8 col-xs-offset-4 checkbox">
                  <Checkbox
                    id="ota-update-deadline-add"
                    checked={this.getFormProp('deadline', false)}
                    onChange={e => {
                      this.onChangeFormDataPropCheckbox('deadline', e);
                    }}
                  />
                  <label htmlFor="ota-update-deadline-add">
                    {__('Deadline')}
                  </label>
                </div>
              </div>
              <div
                className={cx('form-group', {
                  'has-error':
                    'deadline' in formErrors || 'deadlineDate' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Platné do (dátum)')}:
                </label>
                <div className="col-sm-4 col-xs-8">
                  <Datepicker
                    selected={this.getFormProp('deadlineDate', null)}
                    dateFormat="dd.MM.yyyy"
                    onChange={this.onChangeFormDataDeadlineDate}
                    placeholderText="01.01.2000"
                  />
                </div>
              </div>
              <div
                className={cx('form-group', {
                  'has-error':
                    'deadline' in formErrors || 'deadlineTime' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Platné do (čas)')}:
                </label>
                <div className="col-xs-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="00:00"
                    onChange={e => {
                      this.onChangeFormDataProp('deadlineTime', e);
                    }}
                    value={this.getFormProp('deadlineTime')}
                  />
                </div>
              </div>
              <div
                className={cx('form-group', {
                  'has-error': 'ecr_version_min' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Min. verzia ECR')}:
                </label>
                <div className="col-xs-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="0.0.0"
                    onChange={e => {
                      this.onChangeFormDataProp('ecrVersionMin', e);
                    }}
                    value={this.getFormProp('ecrVersionMin')}
                  />
                </div>
              </div>
              <div
                className={cx('form-group', {
                  'has-error': 'icm_version_min' in formErrors,
                })}
              >
                <label className="col-xs-4 control-label">
                  {__('Min. verzia SM')}:
                </label>
                <div className="col-xs-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="0.0.0"
                    onChange={e => {
                      this.onChangeFormDataProp('icmVersionMin', e);
                    }}
                    value={this.getFormProp('icmVersionMin')}
                  />
                </div>
              </div>
            </fieldset>
            <div className="text-center">
              <button type="submit" className="btn btn-primary">
                {__('Odoslať')}
              </button>
            </div>
          </form>
        </Loader>
      </div>
    );
  }
}

FormAdd.contextTypes = {
  router: PropTypes.object,
};

FormAdd.defaultProps = {};

export default connect(state => ({}))(FormAdd);
